import React from 'react';
import { Controller, FormProvider } from 'react-hook-form';
import { Col, Grid, Row } from 'react-styled-flexboxgrid';

import { FormGroup, Input } from '@savgroup-front-common/core/atoms/Form';
import { CreateClaimValues } from '@/types';
import StepLayout from '@/view/app/layout/NewDesignLayout/StepLayout/StepLayout';
import STEP_CONFIG from '@/view/app/Routes/StepConfig';

import messagesForm from './messages';
import usePhoneNumberLoginEnable from './PhoneNumberLoginEnable.hooks';

interface CustomerInvoiceInformationsProps {
  values: CreateClaimValues;
}

const PhoneNumberLoginEnable: React.FC<CustomerInvoiceInformationsProps> = ({
  values,
}) => {
  const { formContext, isLoading, onSubmit } = usePhoneNumberLoginEnable({
    values,
  });

  const {
    formState: { errors, isValid },
    control,
    handleSubmit,
  } = formContext;

  return (
    <FormProvider {...formContext}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <StepLayout
          values={values}
          stepName={STEP_CONFIG.CUSTOMER_INVOICE_INFORMATION}
          isDisabled={!isValid}
          isLoading={isLoading}
        >
          <Grid fluid>
            <Row>
              <Col sm={12} xs={12}>
                <FormGroup>
                  <Controller
                    control={control}
                    name="orderReference"
                    render={({ field }) => {
                      return (
                        <Input
                          name={field.name}
                          value={field.value}
                          label={messagesForm.orderReferenceLabel}
                          disableBrowserAutocomplete
                          onChange={field.onChange}
                          errors={errors}
                          isRequired
                        />
                      );
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={12} xs={12}>
                <FormGroup>
                  <Controller
                    control={control}
                    name="phoneNumber"
                    render={({ field }) => {
                      return (
                        <Input
                          name={field.name}
                          value={field.value}
                          label={messagesForm.phoneNumberLabel}
                          disableBrowserAutocomplete
                          onChange={field.onChange}
                          errors={errors}
                          isRequired
                        />
                      );
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Grid>
        </StepLayout>
      </form>
    </FormProvider>
  );
};

PhoneNumberLoginEnable.displayName = 'PhoneNumberLoginEnable';

export default PhoneNumberLoginEnable;
